import { render, staticRenderFns } from "./PaymentMethodeBtns.vue?vue&type=template&id=f77814d2&"
import script from "./PaymentMethodeBtns.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodeBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports